module.exports = __webpack_public_path__ + "static/media/noPosterSmall.87a0eb6a.png";